// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2z4un","footer":"ModalInfo_footer__1OPk5"};